export default class SnackBar {
  constructor(showSnackParam, snackTextParam, snackTypeParam) {
    this.showSnackParam = showSnackParam
    this.snackTextParam = snackTextParam
    this.snackTypeParam = snackTypeParam
  }
}
